import * as actionTypes from "./actionTypes";
import { productTypes } from "../../data";

export const onFetchProductTypes = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GENERAL_CONTROLS,
      payload: { loading: true },
    });
    setTimeout(() => {
      //firebase code
      const fetchedTypes = productTypes;
      dispatch({
        type: actionTypes.GENERAL_CONTROLS,
        payload: { productTypes: fetchedTypes, loading: false },
      });
    }, 2000);
  };
};

export const testFetch = () => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch({
        type: actionTypes.GENERAL_CONTROLS,
        payload: { dummy: "this is global" },
      });
    }, 1000);
  };
};
